import { EventTypes } from 'redux-segment';

import logger from 'utils/logger.util';

import { EVENT_TRACKING } from './trackEvent.types';

const L = logger('trackEvent');

const trackEvent = L.wrap('()', ({ event, properties }) => ({
  type: EVENT_TRACKING,
  meta: { analytics: { eventType: EventTypes.track, eventPayload: { event, properties } } },
}));

// noinspection JSUnusedGlobalSymbols
export default trackEvent;
